<template lang="pug">
#BusinessGroupView.custom-container
  .section-title Grupos de Empresas
  b-breadcrumb.breadcrumb(:items="breadcrumbs")
  ListGroup
</template>
<script>
import ListGroup from "../components/business_group/ListGroup.vue";
export default {
  data(){
    return{
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { name: 'Home' }
        },
        {
          text: 'Grupos de Empresas',
          active:true
        },
      ]
    }
  },
  components: {
    ListGroup,
  },
};
</script>
